export const NETWORK_ERROR = `Your request could not be processed due to Network Interruption. Please login again.`;
export const INTERNAL_SERVER_ERROR = `Internal server error. Please try again.`;
export const URL_NOTFOUND_ERROR = `The Requested URL was Not Found on this Server.`;
export const UNABLE_TO_PROCESS_ERROR = `Unable to process the request. Please try again.`;
export const SESSION_TIMEOUT_ERROR = `Access is denied due to the session timeout. Please login again.`;
export const SOMETHING_WENT_WRONG = `Something went wrong`;
export const BAD_REQUEST = `Bad Request`;
export const NO_CERTIFICATE_ERROR = `You don’t have any certificates present in CurioZ. Please complete your training and login again.`;
